import styled from 'styled-components';

export const FooterContainer = styled.div`
  width: 100%;
  padding: 0 20px;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px -4px 6px 0px rgba(0, 0, 0, 0.25);
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  width: 33%;
  height: 100%;
  text-align: center;
`;

export const SocialItem = styled.div`
  width: 33%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  height: 100%;
  text-align: center;
`;

export const TextItem = styled.p`
  margin: 0;
  padding: 0;
  text-align: center;
`;

export const FooterLogo = styled.img`
  max-height: 90%;
`;

export const SocialIcon = styled.svg`
  height: 40%;
  margin-right: 5%;
`;
